var RouteKey;
(function(RouteKey) {
    RouteKey["AddressBook"] = 'addressBook';
    RouteKey["Appointments"] = 'appointments';
    RouteKey["ChangePassword"] = 'changePassword';
    RouteKey["CreateAccount"] = 'createAccount';
    RouteKey["LinkExpired"] = 'linkExpired';
    RouteKey["Login"] = 'login';
    RouteKey["Logout"] = 'logout';
    RouteKey["Orders"] = 'orders';
    RouteKey["Prescriptions"] = 'prescriptions';
    RouteKey["Profile"] = 'profile';
    RouteKey["ResetPassword"] = 'resetPassword';
    RouteKey["SetPassword"] = 'setPassword';
    RouteKey["Settings"] = 'settings';
    RouteKey["Signup"] = 'signup';
    RouteKey["Subscriptions"] = 'subscriptions';
    RouteKey["UnlinkOrder"] = 'unlinkOrder';
    RouteKey["Verify"] = 'verify';
})(RouteKey || (RouteKey = {}));

export { RouteKey };
//# sourceMappingURL=routes.js.map
